<template>
  <div class="calendar-view-selector align-items-center">
    <span class="calendar-view-selector__label color-black mr-3 font-17">
      Mes/Año
    </span>
    <div
      v-for="(item, index) in periods"
      :key="'calendarViewSelector' + index"
      class="calendar-view-selector__option"
      :class="[{ active: selected === item.id }]"
      @click="onSelectHandler(item)"
    >
      <div class="calendar-view-selector__month">{{ item.monthShortName }}</div>
      <div class="calendar-view-selector__year">{{ item.year }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/es-do';
export default {
  name: 'PeriodSelector',
  props: {
    periods: {
      type: Array,
      default: () => [],
    },
    selectedPeriod: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    getOptions() {
      let results = [];
      for (let i = 0; i < 3; i++) {
        var _date = moment(new Date())
          .subtract(i, 'months')
          .endOf('month');
        results.unshift({
          id: i,
          month: _date.format('MMM').toUpperCase(),
          year: _date.format('YYYY').toUpperCase(),
          date: _date.format('YYYY-MM-DD'),
        });
      }
      results[0].selected = true;
      return results;
    },
  },
  watch: {
    selectedPeriod: {
      immediate: true,
      handler(val) {
        this.selected = val;
      },
    },
  },
  methods: {
    onSelectHandler(item) {
      this.selected = item.id;
      this.$emit('on-select-period', item);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.calendar-view-selector {
  display: flex;
  cursor: pointer;
  &__option {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: map-get($colors, 'gray-7');
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 3px;
    padding-bottom: 3px;

    span {
      user-select: none;
    }

    &.active {
      border-radius: 30px;
      background: map-get($colors, 'orange');
      color: map-get($colors, 'white');
    }

    @media only screen and (min-width: 768px) {
      min-width: 105px;
      min-height: 38px;
    }
  }
  &__month {
    font-weight: bold;
    font-size: 15px;
  }
  &__year {
    font-size: 13px;
  }

  &__label {
    font-weight: bold;
  }
}

@media only screen and (max-width: 768px) {
  .calendar-view-selector {
    &__label {
      font-weight: bold;
      font-size: 10px !important;
    }

    &__option {
      width: 75px;
    }

    &__month,
    &__year {
      font-size: 10px;
      font-weight: normal;
    }

    &__month {
      font-weight: bold;
    }
  }
}
</style>
